const themeId = process.env.GATSBY_FOR || ' '

const theme = require(`src/themes/${themeId}`).default

export default theme
